import * as React from 'react';
import jwtDecode from 'jwt-decode';
import LoginUI from './Login'
import { LoginApiHandler } from '../../network/requests';
import { sendEvents } from '../../utils/events';
import { events } from '../../utils/constants';

var user = localStorage.getItem("user");

const Login = ({ children }) => {
    const buttonRef = React.useRef();

    const loginComplete = (user) => {
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("isLoggedIn", true);
        sendEvents(events.USER_LOGIN, { user });
        window.location.reload();
    }

    const handleCallbackResponse = async (respone) => {
        const userObject = jwtDecode(respone.credential)
        try {
            const data = await LoginApiHandler.loginWithToken({ tokenID: respone.credential });
            userObject.accessToken = data.accessToken;
            loginComplete(userObject);
        } catch (err) {
            console.log(err);
        }
    }

    const initiatieGoogleLogin = () => {
        if (user) {
            return console.log("Logged In")
        }
        /* global google */
        if (google) {
            google.accounts.id.initialize({
                client_id: "789381746254-2rbf0peb8on3qgf3bk6s9m511oa6eg8l.apps.googleusercontent.com",
                callback: handleCallbackResponse
            })
            google.accounts.id.renderButton(
                buttonRef.current,
                { theme: "filled_black", size: "large" }
            )
        } else {
            setTimeout(initiatieGoogleLogin, 500)
        }
    }
    React.useEffect(initiatieGoogleLogin, [])

    return <div className='App'>
        {!user ? <LoginUI >
            <div ref={buttonRef} style={{ margin: "auto" }} />
        </LoginUI> : children}
    </div>
}
export default Login